import React from "react";
import { SvgBoxProps, SvgBox } from "@govlaunch/web";

export default function MyGovernmentIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M10.2827 6.31713C11.1966 5.28891 12.8032 5.28891 13.7171 6.31713C14.3325 7.00959 15.1553 7.48461 16.0627 7.67139C17.4101 7.94874 18.2134 9.34005 17.7799 10.6456C17.4879 11.5249 17.4879 12.4749 17.7799 13.3541C18.2134 14.6597 17.4101 16.051 16.0627 16.3284C15.1553 16.5152 14.3325 16.9902 13.7171 17.6826C12.8032 18.7109 11.1966 18.7109 10.2827 17.6826C9.66724 16.9902 8.84448 16.5152 7.93707 16.3284C6.58965 16.051 5.78637 14.6597 6.21989 13.3541C6.51184 12.4749 6.51184 11.5249 6.21989 10.6456C5.78637 9.34005 6.58965 7.94874 7.93707 7.67139C8.84448 7.48461 9.66724 7.00959 10.2827 6.31713Z"
        fill="white"
        stroke="#3F4A5A"
        strokeWidth="2"
      />
      <circle cx="12" cy="12" r="10.75" stroke="#3F4A5A" strokeWidth="2.5" />
      <circle cx="12.0001" cy="12.0001" r="2.4" fill="#3F4A5A" />
      <circle cx="12.0001" cy="12.0001" r="2.4" stroke="#3F4A5A" />
    </SvgBox>
  );
}
